import { useEffect, useState } from "react";

import {
    Badge,
    Button,
    Card,
    CardBody,
    Container,
    Spinner,
    Table
} from "reactstrap";
 
import { GroupJoinRequestDto } from "../types/MyGroupStatus";
import { approveRequest, getGroupRequests, rejectRequest } from "../Services/GroupJoinRequestService";

interface Props {

    groupId: string;

}

const GroupJoinRequestPage = ({
    groupId
}: Props) => {

    const [loading, setLoading] =
        useState(true);

    const [requests, setRequests] =
        useState<GroupJoinRequestDto[]>([]);

    useEffect(() => {

        loadRequests();
// eslint-disable-next-line
    }, []);

    const loadRequests = async () => {

        setLoading(true);

        try {

            const response =
                await getGroupRequests(groupId);

            setRequests(response);

        }
        finally {

            setLoading(false);

        }

    };

    const approve = async (requestId: string) => {

        await approveRequest(requestId);

        loadRequests();

    };

    const reject = async (requestId: string) => {

        const remarks =
            prompt("Reason for rejection");

        if (!remarks)
            return;

        await rejectRequest(
            requestId,
            remarks
        );

        loadRequests();

    };

    if (loading)
        return <Spinner />;

    return (

        <Container>

            <Card>

                <CardBody>

                    <h4>

                        Join Requests

                    </h4>

                    <Table responsive>

                        <thead>

                            <tr>

                                <th>Name</th>

                                <th>Email</th>

                                <th>Status</th>

                                <th>Requested</th>

                                <th></th>

                            </tr>

                        </thead>

                        <tbody>

                            {requests.map(request => (

                                <tr
                                    key={request.groupJoinRequestId}
                                >

                                    <td>

                                        {request.userName}

                                    </td>

                                    <td>

                                        {request.email}

                                    </td>

                                    <td>

                                        {request.status}

                                    </td>

                                    <td>

                                        {new Date(
                                            request.requestedAt
                                        ).toLocaleDateString()}

                                    </td>

                                    <td>

                                      {request.status === "Pending" ? (
    <>
        <Button
            color="success"
            size="sm"
            className="me-2"
            onClick={() => approve(request.groupJoinRequestId)}
        >
            Approve
        </Button>

        <Button
            color="danger"
            size="sm"
            onClick={() => reject(request.groupJoinRequestId)}
        >
            Reject
        </Button>
    </>
) : (
    <Badge
        color={
            request.status === "Approved"
                ? "success"
                : "danger"
        }
    >
        {request.status}
    </Badge>
)}

                                    </td>

                                </tr>

                            ))}

                        </tbody>

                    </Table>

                </CardBody>

            </Card>

        </Container>

    );

};

export default GroupJoinRequestPage;